export const APP_LOGO =
  "https://betazen.s3.ap-south-1.amazonaws.com/app_logo.png";
export const APP_BANNER =
  "https://betazen.s3.ap-south-1.amazonaws.com/appBanner.png";
export const APP_ID =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYiI6ImJldGF6ZW4iLCJuYW1lIjoiQmV0YVplbiBBcHAiLCJpYXQiOjE3NDMwMTM0NzgsImV4cCI6MTc3NDU0OTQ3OH0.1kHYNwWPOVYXghlY-dJTXVGNd730-FgVuqio_1t9B9k";
export const LOCAL = "local";
export const ADMIN = "admin";
export const USER = "user";
export const PRODUCTION = "production";
export const EMPLOYEE = "Employee";
export const VISITORS = "visitors";
export const MEETINGS = "meetings";
export const GATEKEEPER = "Gatekeeper";
export const state = PRODUCTION;
export const API_ENDPOINT =
  state === PRODUCTION ? "https://api.betazen.in/" : "http://localhost:5000/";

export const TimeZoneIndia = {
  timeZone: "Asia/Kolkata", // IST Timezone
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};
export const TimeOnlyZone = {
  timeZone: "Asia/Kolkata",
  hour: "2-digit",
  minute: "2-digit",
};
